import { render, staticRenderFns } from "./IncomeSourceList.vue?vue&type=template&id=f0f824e6"
import script from "./IncomeSourceList.vue?vue&type=script&lang=js"
export * from "./IncomeSourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports